import React from 'react';
import { components as reactSelectComponents } from 'react-select';

const renderInput = (Component = reactSelectComponents.Input) => {
  const WrappedComponent = (inputProps) => <Component {...inputProps} isHidden={false} />;

  WrappedComponent.displayName = 'renderInput';

  return WrappedComponent;
};

export default renderInput;
